(function () {
  function init() {
    var variantsScript = document.querySelector('[data-product-variants-json]');
    var optionsScript = document.querySelector('[data-product-option-values-json]');
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!variantsScript || !optionsScript || !idInput) return;

    var variants = JSON.parse(variantsScript.textContent);
    var optionsWithValues = JSON.parse(optionsScript.textContent);
    var sectionId = variantsScript.getAttribute('data-product-variants-json');
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return;

    // Optionswerte pro Optionsposition, damit ein Tag seiner Option zugeordnet
    // werden kann (Position 0 = Farbe, Position 1 = Menge o. ae.).
    var optionValueSets = optionsWithValues.map(function (opt) {
      return opt.values.map(function (v) { return String(v).toLowerCase(); });
    });

    function optionIndexOf(tag) {
      for (var k = 0; k < optionValueSets.length; k++) {
        if (optionValueSets[k].indexOf(tag) !== -1) return k;
      }
      return -1;
    }

    var knownValues = [];
    optionValueSets.forEach(function (values) {
      values.forEach(function (v) { knownValues.push(v); });
    });

    var slides = gallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
    var tagMap = new Map();
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      var alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
      var tags = knownValues.filter(function (kw) {
        return alt.indexOf('[' + kw + ']') !== -1;
      });
      tagMap.set(slide, tags);
    });

    // Welche Optionswerte kommen ueberhaupt als Bild-Tag vor.
    var taggedByOption = optionValueSets.map(function () { return []; });
    slides.forEach(function (slide) {
      (tagMap.get(slide) || []).forEach(function (tag) {
        var k = optionIndexOf(tag);
        if (k !== -1 && taggedByOption[k].indexOf(tag) === -1) taggedByOption[k].push(tag);
      });
    });

    // Getaggte Variantenbilder aktiv vorladen,
    // damit sie beim Variantenwechsel sofort verfuegbar sind
    slides.forEach(function (slide) {
      var tags = tagMap.get(slide) || [];
      if (tags.length > 0) {
        var img = slide.querySelector('img');
        if (img) {
          img.removeAttribute('loading');
          var preload = new Image();
          if (img.srcset) {
            preload.srcset = img.srcset;
            preload.sizes = img.sizes;
          }
          preload.src = img.currentSrc || img.src;
        }
      }
    });

    function viewerEl() {
      return gallery.querySelector('[id^="GalleryViewer"]') || gallery;
    }

    /*
      Warum ein Tag nicht immer zaehlt:

      Die Farbbilder sind mit ZWEI Tags versehen, z. B. "[2er Pack][Rosa/Weiss]".
      Fuer 4er Pack und 6er Pack existieren gar keine getaggten Bilder. Die alte
      Regel verlangte, dass ALLE Tags passen. Sobald das 4er Pack gewaehlt war,
      fiel schon "[2er Pack]" durch und saemtliche Farbbilder verschwanden.

      Neue Regel: Ein Tag schraenkt nur dann ein, wenn es fuer den aktuell
      gewaehlten Wert DIESER Option ueberhaupt getaggte Bilder gibt. Fuer die
      Menge trifft das nur beim 2er Pack zu, also wird die Menge bei 4er und 6er
      ignoriert und nur nach Farbe gefiltert. Das Farbbild erscheint damit in
      jeder Box.
    */
    function isVisibleForSelection(slide, selected) {
      var tags = tagMap.get(slide) || [];
      return tags.every(function (tag) {
        var k = optionIndexOf(tag);
        if (k === -1) return true;
        if (taggedByOption[k].indexOf(selected[k]) === -1) return true;
        return tag === selected[k];
      });
    }

    var adjusting = false;

    // Nach dem Filtern soll immer das passende Variantenbild gross stehen.
    // Das Theme laeuft im Layout product--thumbnail_slider, dort ist nur das
    // Medium mit is-active sichtbar. Bevorzugt wird das erste sichtbare
    // getaggte Bild, sonst das erste sichtbare ueberhaupt.
    function showBestMedia() {
      if (adjusting) return;

      var items = viewerEl().querySelectorAll('.product__media-item');
      var firstTagged = null;
      var firstVisible = null;

      items.forEach(function (el) {
        if (el.classList.contains('variant-media-hidden')) return;
        if (!firstVisible) firstVisible = el;
        if (!firstTagged && (tagMap.get(el) || []).length > 0) firstTagged = el;
      });

      var target = firstTagged || firstVisible;
      if (!target) return;
      if (target.classList.contains('is-active')) return;

      var mediaId = target.getAttribute('data-media-id');
      if (!mediaId) return;

      adjusting = true;
      try {
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(mediaId, true);
        } else {
          items.forEach(function (el) { el.classList.remove('is-active'); });
          target.classList.add('is-active');
        }
      } finally {
        adjusting = false;
      }
    }

    function applyFilter(variantId) {
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (!variant) return;

      var selected = (variant.options || []).map(function (o) { return String(o).toLowerCase(); });

      slides.forEach(function (slide) {
        slide.classList.toggle('variant-media-hidden', !isVisibleForSelection(slide, selected));
      });

      showBestMedia();
    }

    var lastValue = null;
    function check() {
      if (idInput.value !== lastValue) {
        lastValue = idInput.value;
        applyFilter(lastValue);
      }
    }
    check();
    setInterval(check, 300);

    // Filter synchron VOR Dawns setActiveMedia ausfuehren,
    // damit Scroll- und Offset-Berechnungen mit dem korrekten Layout passieren
    var MediaGalleryClass = customElements.get('media-gallery');
    if (MediaGalleryClass && !MediaGalleryClass.prototype.__variantFilterPatched) {
      var originalSetActiveMedia = MediaGalleryClass.prototype.setActiveMedia;
      MediaGalleryClass.prototype.setActiveMedia = function (mediaId, prepend) {
        check();
        return originalSetActiveMedia.call(this, mediaId, prepend);
      };
      MediaGalleryClass.prototype.__variantFilterPatched = true;
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
